import { useMemo } from "react";
import { useSize } from "./use-size";
import { ITEM_INDEX_PROP } from "./constants";
const defaultItemSize = { width: 0, height: 0 };

export const useTrackMetrics = (trackRef, items, offsetProp) => {
  const trackSize = useSize(trackRef, true);
  const itemSizes = useMemo(() => {
    const sizes = trackSize.width
      ? Array.from(
          trackRef.current.querySelectorAll(`[${ITEM_INDEX_PROP}]`)
        ).reduce((res, el) => {
          const itemIndex = el.getAttribute(ITEM_INDEX_PROP);
          return {
            ...res,
            [itemIndex]: res[itemIndex] || {
              width: el.offsetWidth,
              height: el.offsetHeight
            }
          };
        }, {})
      : [];
    return items.map((_, i) => sizes[i] || defaultItemSize);
  }, [trackSize, items, trackRef]);
  const [offsets, contentSize, minHeight, maxHeight] = useMemo(() => {
    let minHeight = itemSizes[0].height;
    let maxHeight = itemSizes[0].height;
    let offset = 0;
    let offsets = [];
    for (let i = 0; i < items.length; i++) {
      let itemSize = itemSizes[i];
      if (itemSize) {
        offsets[i] = offset;
        offset = offset + itemSize[offsetProp];
        maxHeight = Math.max(maxHeight, itemSize.height);
        minHeight = Math.min(minHeight, itemSize.height);
      }
    }
    return [offsets, offset, minHeight, maxHeight];
  }, [items, itemSizes, offsetProp]);
  return useMemo(
    () => ({
      trackSize,
      contentSize,
      itemSizes,
      offsets,
      maxHeight,
      minHeight
    }),
    [trackSize, contentSize, itemSizes, offsets, minHeight, maxHeight]
  );
};
